import React from "react";

const OnlineOptionsBus = (props) => {
  const options = [
    {
      text: 'Help, I’m having trouble with Interac Debit for Online Payments.',
      handler: props.actionProvider.OnlineBus1,
      id: 1
    },
    {
      text: 'What is Interac Debit for Online Payments and how does it work?',
      handler: props.actionProvider.OnlineBus2,
      id: 2
    },
    {
      text: 'What if a customer doesn’t use online banking?',
      handler: props.actionProvider.OnlineBus3,
      id: 3
    },
    {
      text: 'Why does the customer have to leave my website? What if they don’t come back?',
      handler: props.actionProvider.OnlineBus4,
      id: 4
    },
    {
      text: 'How do I handle refunds?',
      handler: props.actionProvider.OnlineBus5,
      id: 5
    },
    {
      text: 'What is a chargeback and does Interac issue them?',
      handler: props.actionProvider.OnlineBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default OnlineOptionsBus;